<template>
    <svg-injector v-if="this.src" :class-name="classes" :src="src"></svg-injector>
</template>

<script>

export default {
    name: 'SvgIcon',
    props: {
        icon: null,
        dir: {
            type: String,
            default: 'icons'
        },
        title: null,
        size: {
            type: String,
            default: '24'
        }
    },
    data: function () {
        return {
            src: null,
            classes: 'js-svg-injector',
            images: {}
        }
    },
    computed: {
       
    },
    created() {
        try {
            this.src = require('../assets/' + this.dir + '/' + this.icon + '.svg');
            this.src = process.env.VUE_APP_KARTTAMAP_PATH + this.src;
        } catch (ex) {
            // Icon doesn't exist
        }

        if (this.size) {
            this.classes += ' size-' + this.size;
        }
    },
    mounted() {
        // Set SVG title if defined
        if (this.src && this.title) {
            var titleEl = this.$el.getElementsByTagName('title')[0];
            
            if (titleEl) {
                titleEl.textContent = this.title;
            }
        }
    }
}

</script>

<style scoped>

</style>
